//Ignore any TS errors here bcaus the d3 and html references don't play very well
//@ts-nocheck
import * as React from 'react';
import {TileRange} from "../Helpers/SharedClasses"
import * as d3 from 'd3';
import {GaugeColorPicker} from './GaugeColorPicker';

class GaugeTile extends React.PureComponent<{context: string, enableColouring: boolean,valueStale: boolean, title: string,value: number,
  subValue: number, subValueUom: string, uom: string,includeSubValue: boolean, defaultColor: string, maxValue: number,
  includeEdit: boolean, goodRange: TileRange, badRange: TileRange, worstRange: TileRange, wideTile: boolean, expanded: boolean, referenceValueStyle: string, 
  tileClicked: Function, tileValueChanged: Function, onConfigChanged?: (config: any) => void, reverseValues: boolean, goodColor: string, badColor: string, worstColor: string, goodClass: string, badClass: string, worstClass: string, overridename: string, sizeFactor: number,setRefValueMode?: boolean, loadableRefValueMode?: boolean }, { isediting: boolean, isColorPickerVisible: boolean, clickedRegion: any  } >
 {

    constructor(props: any) {
        super(props);
        this.state = {
          isediting: false,
          isColorPickerVisible: true,
          clickedRegion: {
            zone: "goodColor", // Default zone
            color: this.props.goodColor // Default color
          }
        };
    }

    componentDidMount = () => {
      
      this.drawReferenceValuesGauge();
    }

      componentDidUpdate = () =>
      {
        
        this.drawReferenceValuesGauge();
        
      }

      static defaultProps = {
        context: "TTFM",
        title: "ML",
        uom: "mL/min",
        value: "--",
        sizeFactor:1,
        subValue: "",
        status: 0,
        subValueUom: "",
        enableColouring: true,
        defaultColor: "tile-no-data",
        includeEdit: false,
        includeSubValue: false,
        referenceValueStyle: "Bar",
        reverseValues: false,
        worstColor: "var(--BernRed)",
        badColor: "var(--BananaClan)",
        goodColor: "var(--GreenApple)",
        worstClass: "tile-redlight",
        badClass: "tile-yellowlight",
        goodClass: "tile-greenlight",
        goodRange: {
           min: -1,
           max: 0
        },
        badRange: {
          min: 90,
          max: 99
       },
       worstRange: {
        min: 100,
        max: 1000
      },
      wideTile: false,
      maxValue: 10000,
      expanded: true,
      valueStale: false,
      setRefValueMode: false,
      loadableRefValueMode: false,
      tileValueChanged: ()=>{},
      onConfigChanged: ()=>{}
      }

      resizeGauge = () =>
      {
        this.clearReferenceValuesBar();
        this.gaugeCreated = null;
      }

      
      toggleColorPicker = (e: React.MouseEvent, zoneInfo?: any) => {
        e.stopPropagation();
        
        this.setState(prevState => ({
          isColorPickerVisible: !prevState.isColorPickerVisible,
          // Update clickedRegion if zoneInfo is provided, extract only what we need
          clickedRegion: zoneInfo ? {
            zone: zoneInfo.zone,
            color: zoneInfo.color
            // We don't need min, max, yValue, heightValue from zoneInfo
          } : prevState.clickedRegion
        }));
      }

      handleColorChange = (newColor: string) => {
        if (this.props.onConfigChanged) {
          const config: any = {};
          config[this.state.clickedRegion.zone] = newColor;
          this.props.onConfigChanged(config);
        }
        this.setState(prevState =>({ isColorPickerVisible: !prevState.isColorPickerVisible }));
      }

      getColorPickerPosition = (): string => {
        const { clickedRegion } = this.state;
        
        switch (clickedRegion.zone) {
          case 'goodColor':
            return '0%'; // Position to the left
          case 'badColor':
            return '17%'; // Position in the center
          case 'worstColor':
            return '50%'; // Position to the right
          default:
            return '25%'; // Default to center
        }
      }

      getLightColorForTile()
      {
        if (this.props.enableColouring)
        {
            if (this.props.value >= this.props.goodRange.min &&  this.props.value <= this.props.goodRange.max )
            {
              return this.props.goodClass;
            }
            else if (this.props.value >= this.props.badRange.min &&  this.props.value <= this.props.badRange.max )
            {
              return this.props.badClass;
            }
            else if (this.props.value >= this.props.worstRange.min &&  this.props.value <= this.props.worstRange.max )
            {
              return this.props.worstClass;
            }

            return this.props.defaultColor;
        }
        else
        {
          return this.props.defaultColor;
        }
      }

      calculateValueOnAxis(value: any, axisMin: any, axisMax: any, axisLength: any, axisOffset: any)
      {
        return axisLength*(value/(axisMax - axisMin)) + axisOffset;
      }

      calculateValueOnAxisEvenParts(value: any, axisMin: any, axisMax: any, axisLength: any, axisOffset: any)
      {
        let valuePercentage = value/(axisMax - axisMin);
        let numberOfParts = 3;
        
        let partsPercentage = 1/numberOfParts;
        for (let index = 0; index < numberOfParts; index++) {
            if (partsPercentage * index <= valuePercentage && partsPercentage * (index +1) <= valuePercentage )
            {
              //return partNumber;
              return [axisLength*(partsPercentage * (index) ) + axisOffset, axisLength*(partsPercentage * (index +1) ) + axisOffset] ;
            }
        }
        return [0, axisLength + axisOffset];
        // if (1 * partsPercentage  )
        // partNumber

        // let eachLength = axisLength/numberOfParts;
        // if (eachLength)
        // return axisLength*(value/(axisMax - axisMin)) + axisOffset;
      }

      calculateZone(value: any, axisMin: any, axisMax: any)
      {
        let valuePercentage = value/(axisMax - axisMin);
        let numberOfParts = 3;

        let partsPercentage = 1/numberOfParts;
        for (let index = 0; index < numberOfParts; index++) {
            if (partsPercentage * index <= valuePercentage && valuePercentage <= partsPercentage * (index +1) )
            {
              //return partNumber;
             return index;
            }
        }
        return 0;
        // if (1 * partsPercentage  )
        // partNumber

        // let eachLength = axisLength/numberOfParts;
        // if (eachLength)
        // return axisLength*(value/(axisMax - axisMin)) + axisOffset;
      }

      calculateZoneOrders = () =>
        {
           let ZoneList = [{
             color: this.props.goodColor,
             min: this.props.goodRange.min,
             max: this.props.goodRange.max,
             yValue: 0,
             heightValue: 0,
             zone: "goodColor"
           }
           ,{
            color: this.props.badColor,
            min: this.props.badRange.min,
            max: this.props.badRange.max,
            yValue: 0,
            heightValue: 0,
            zone: "badColor"
          },
          {
            color: this.props.worstColor,
            min: this.props.worstRange.min,
            max: this.props.worstRange.max,
            yValue: 0,
            heightValue: 0,
            zone: "worstColor"
          }
          ];
          //If the worst range is zero then don't display it a worst range.
          if ((this.props.worstRange.min === 0 && this.props.worstRange.max === 0))
          {
            ZoneList[2].color = this.props.badColor;
          }
  
          for (let mainindex = 0; mainindex < ZoneList.length; mainindex++) {
          for (let index = mainindex+1; index < ZoneList.length; index++) {
            const element = ZoneList[mainindex];
            const element1 = ZoneList[index];
            if (element1.max > element.max)
            {
              //If they are out of order then Swap.
              ZoneList[mainindex] = element1;
              ZoneList[index] = element;
            }
          }
        }
        if (this.props.reverseValues)
          return ZoneList.reverse();
        else
          return ZoneList;
        }
  

      getZoneBasedOnPosition = (valueIn: any, zoneList: any) =>
      {
   
        let value = parseFloat(valueIn);
        let zoneItIsIn = null;
        for (let index = 0; index < zoneList.length; index++) {
          const element = zoneList[index];
          if (!zoneItIsIn && element.min <= value && value <= element.max )
          {
            zoneItIsIn = element;
          }
        }
      
        if (zoneItIsIn === null){
            //If its below the minimum range then set to the first range.
            if (zoneList[zoneList.length - 1].min > value)
            {
           
              zoneItIsIn = zoneList[zoneList.length - 1];
            }else if (zoneList[0].max < value)
            {
              
              zoneItIsIn = zoneList[0];
            }else
            {
              //This should be impossible!
              
              zoneItIsIn = zoneList[1];
            }
        }

        return zoneItIsIn;
      }

      getZoneIndexBasedOnPosition = (valueIn, zoneList) =>
      {
        let zoneIndex = -1;
        let value = parseFloat(valueIn);

        for (let index = 0; index < zoneList.length; index++) {
          const element = zoneList[index];
          if (zoneIndex  === -1 && element.min <= value && value <= element.max )
          {
            zoneIndex = index;

          }
        }

        if (zoneIndex  === -1){
            //If its below the minimum range then set to the first range.

            let startZone = zoneList.length - 1;
            let endZone = 0;
            if (this.props.reverseValues)
            {
            startZone = 0;
            endZone = zoneList.length - 1;
            }
            if (zoneList[startZone].min > value)
            {
           
              zoneIndex = startZone;
            }else if (zoneList[endZone].max < value)
            {
              
              zoneIndex = endZone;
            }else
            {
              //This should be impossible!
             
              zoneIndex = 1;
            }
        }
        // if (this.props.reverseValues)
        //     return (zoneList.length - zoneIndex);
        // else
            return zoneIndex;
      }

      getPositionBasedOnZone = (valueIn: any, zoneList: any, returnPercent = false) =>
      {
   
        let value = parseFloat(valueIn);
        let zoneItIsIn = null;
        for (let index = 0; index < zoneList.length; index++) {
          const element = zoneList[index];
          if (!zoneItIsIn && element.min <= value && value <= element.max )
          {
            zoneItIsIn = element;
          }
        }
        let percentPos = 0;
        if (zoneItIsIn === null){

          let startZone = zoneList.length - 1;
          let endZone = 0;
          if (this.props.reverseValues)
          {
          startZone = 0;
          endZone = zoneList.length - 1;
          }
            //If its below the minimum range then set to the first range.
            if (zoneList[startZone].min > value)
            {
              percentPos = 0;
              zoneItIsIn = zoneList[startZone];
            }else if (zoneList[endZone].max < value)
            {
              percentPos = 1;
              zoneItIsIn = zoneList[endZone];
            }else
            {
              //This should be impossible!
              percentPos = 0.5;
              zoneItIsIn = zoneList[1];
            }
        }else
        {

        let range = (zoneItIsIn.max - zoneItIsIn.min);
        if (range === 0)
        {
          //If there is no range make the value 100%
          
          range = value;
        }
        if (range === 0)
        {
          percentPos = 0;
        }else
        {
            percentPos = (value - zoneItIsIn.min) /range;
        }
      }
      if (returnPercent)
      {  
         if (this.props.reverseValues)
        return 1-percentPos;
        else
        return percentPos;
      }
      else
      {

      let drawnPos = (1-percentPos) * zoneItIsIn.heightValue + zoneItIsIn.yValue;
      return drawnPos;
      } 
      }

      clearReferenceValuesBar = () =>
      {
        d3
        .selectAll("#gauge-" + this.props.overridename+"-ttfm-gauge-" + this.props.title + "-" + this.props.context + ' .ttfm-gauge-reference-values')
        .select("svg")
        .remove();
      }

      orderValueRanges = () =>
      {
        //  let
      }

     deg2rad = (deg: any) => {
        return deg * Math.PI / 180;
      }
      
      newAngle = (d: any, config: any) => {

        var ratio = this.scaleGauge(d);
        var newAngle = config.minAngle + (ratio * this.rangeGauge);
        return newAngle;
      }
      
      rangeGauge = null;
      scaleGauge = null;
      pointerGauge = null;
      pointerHeadLength = null;
      arcGauge = null;
      tickData = null;
      ticksGauge = null;
      gaugeCreated = null;

      configure = (configuration) => {
    
        
        this.rangeGauge = configuration.maxAngle - configuration.minAngle;
        let r = configuration.size / 2;
        
        this.pointerHeadLength = Math.round(r * configuration.pointerHeadLengthPercent);
    
        // a linear scale that maps domain values to a percent from 0..1
        this.scaleGauge = d3.scaleLinear()
          .range([0,1])
          .domain([configuration.minValue, configuration.maxValue]);
          let ticksOut = [];
          for (let index = this.ZoneList.length-1; index >= 1; index--) {
              const element = this.ZoneList[index];
              if (this.props.reverseValues)
                ticksOut.push({index: index, caption:  element.min});
              else
                ticksOut.push({index: index, caption:  element.max});
          }   
         
          
        this.ticksGauge =  ticksOut;//this.scaleGauge.ticks(configuration.majorTicks-2);
        this.tickData = d3.range(configuration.majorTicks).map(function() {return 1/configuration.majorTicks;});
        let thisHolder = this;
         this.arcGauge = d3.arc()
          .innerRadius(r - configuration.ringWidth - configuration.ringInset)
          .outerRadius(r - configuration.ringInset)
          .startAngle(function(d, i) {
            let dIn = d as any;
            var ratio = dIn * i;
            return thisHolder.deg2rad(configuration.minAngle + (ratio * thisHolder.rangeGauge));
          })
          .endAngle(function(d, i) {
            let dIn = d as any;
            var ratio = dIn * (i+1);
            return thisHolder.deg2rad(configuration.minAngle + (ratio * thisHolder.rangeGauge));
          });
      }
        
      centerTranslation = (r, xOffset) =>{
        let xPos = r + xOffset;
        return 'translate('+xPos +','+ r +')';
      }

      renderOverlayInputs = () => {
        if (!this.props.setRefValueMode) {
          return null;
        }
        
        return (
          <div className="gauge-overlay-inputs" >
            {/* Lower Value Input */}
            <div className="gauge-overlay-input-container gauge-overlay-input-left" >
              <input 
                type="text" 
                className="gauge-overlay-input"
                defaultValue={this.props.goodRange.max}
                onChange={(e) => {
                  e.stopPropagation();
                  const val = parseFloat(e.target.value);
                  if (!isNaN(val)) {
                    this.props.onConfigChanged && this.props.onConfigChanged({refValues:{min:val, max:this.props.worstRange.min}});
                  }
                }}
                
                onClick={(e) => e.stopPropagation()}
              />
            </div>
            
            {/* Higher Value Input */}
            <div className="gauge-overlay-input-container gauge-overlay-input-right" >
              <input 
                type="text" 
                className="gauge-overlay-input"
                defaultValue={this.props.worstRange.min}
                onChange={(e) => {
                  e.stopPropagation();
                  const val = parseFloat(e.target.value);
                  if (!isNaN(val)) {
                    this.props.onConfigChanged && this.props.onConfigChanged({refValues:{max:val, min:this.props.goodRange.max}});
                  }
                }}
                onClick={(e) => e.stopPropagation()}
              />
            </div>
            
            {/* Color Picker Button */}
            <div 
            className="color-picker-container" 
            style={{ left: this.getColorPickerPosition() }}>
              
              
              {!this.state.isColorPickerVisible && (
                <GaugeColorPicker 
                  region={this.state.clickedRegion.zone}
                  currentColor={this.state.clickedRegion.color}
                  onColorChange={this.handleColorChange}
                />
              )}
            </div>
          </div>
        );
      }
    

      renderGauge = (newValue, config, svg) => {
    
        var that = this;
        let r = config.size / 2;
        var centerTx = this.centerTranslation(r, config.xOffset);
        
        var arcs = svg.append('g')
            .attr('class', 'arc')
            .attr('transform', centerTx);

        const self = this;
        
        arcs.selectAll('path')
            .data(this.tickData)
          .enter().append('path')
            .attr('fill', function(d, i) {
              return config.arcColorFn(d * i);
            })
            .attr('d', this.arcGauge)
            .attr('data-gaugeT', function(d, i) {
              return d;
            })
            .style('cursor', 'pointer') // Change cursor to indicate clickable
             .on('click', function(event, d, i) {

                // Find position of this element among its siblings
              let nodes = d3.selectAll(this.parentNode.childNodes);
              let clickedIndex = Array.from(nodes).indexOf(this);
              

              let zoneIndex = thisHolder.ZoneList.length - 1 - clickedIndex;
              
              let zoneInfo = thisHolder.ZoneList[zoneIndex];
              self.toggleColorPicker(event, zoneInfo);

            
              
            });


            let thisHolder = this;
            var lg = svg.append('g')
            .attr('class', 'label')
            .attr('transform', centerTx);
        if(!this.props.setRefValueMode)
        {
        lg.selectAll('text')
            .data(this.ticksGauge)
          .enter().append('text')
            .attr('transform', function(d) {
              thisHolder.scaleGauge(d);
              var newAngle = 60*(that.ZoneList.length - d.index) + config.minAngle -5;
              return 'rotate(' +newAngle +') translate(0,' +(config.labelInset - r) +')';
            })
            .text(function(d) {
              return d.caption;
            });
          }
      
    
        var lineData = [ [config.pointerWidth / 2, 0], 
                [0, -this.pointerHeadLength],
                [-(config.pointerWidth / 2), 0],
                [0, config.pointerTailLength],
                [config.pointerWidth / 2, 0] ];
        var pointerLine = d3.line().curve(d3.curveLinear)
        var pg = svg.append('g').data([lineData])
            .attr('class', 'pointer')
            .attr('transform', centerTx);
            
            this.pointerGauge = pg.append('path')
          .attr('d', pointerLine/*function(d) { return pointerLine(d) +'Z';}*/ )
          .attr('transform', 'rotate(' +config.minAngle +')');
          
          this.update(newValue === undefined ? 0 : newValue, config, svg);
      }

      update = (newValue, config, svg) => {

        let newAngle = -90;
        if (newValue !== "--")
         {

            let positionInZone = this.getPositionBasedOnZone(newValue, this.ZoneList, true);

            let ZoneIndex = (this.ZoneList.length - this.getZoneIndexBasedOnPosition(newValue, this.ZoneList))-1;
            newAngle = ZoneIndex*60 + (60)*positionInZone + config.minAngle;
         }

        this.pointerGauge.transition()
          .duration(config.transitionMs)
          .ease(d3.easeElastic)
          .attr('transform', 'rotate(' +newAngle +')');
      }

      gauge = (container, configuration, svg) => {
      };

      ZoneList = null;
      majorTicks = null;

      drawReferenceValuesGauge = () =>
      {

        this.majorTicks = 3;
        this.ZoneList = this.calculateZoneOrders();

        var widthToUse = document.getElementById("gauge-"+this.props.overridename+"-ttfm-gauge-" + this.props.title+ "-" + this.props.context).offsetWidth;
        //var widthToUse = (document.getElementsByClassName("tile-container")[0] as HTMLElement).offsetWidth/5 -60 ;
        var heightToUse = widthToUse/2;
        let gaugeWidth = widthToUse;
        let xOffset = 0;
        if (this.props.sizeFactor > 1)
        {
          if (heightToUse > 40)
          {
            //If the gauge is larger than 180 in height then rather adjust the width.
            heightToUse = 70; 
            xOffset = widthToUse/2 - heightToUse;
            gaugeWidth = heightToUse*2;
          }
        }else
        {
        
        if (heightToUse > 80)
        {
          //If the gauge is larger than 180 in height then rather adjust the width.
          heightToUse = 100; 
          xOffset = widthToUse/2 - heightToUse;
          gaugeWidth = heightToUse*2;
        }
      }
        (document.getElementById("gauge-"+this.props.overridename+"-ttfm-gauge-" + this.props.title+ "-" + this.props.context).getElementsByClassName("gauge-middle")[0] as HTMLElement).style.height = heightToUse + "px";
        let defaultGaugeConfig = {
            size						: gaugeWidth,
            ringInset					: 30,
            ringWidth					: 42,
            xOffset           : xOffset,
            pointerWidth				: 20,
            pointerTailLength			: 4,
            pointerHeadLengthPercent	: 0.70,
            
            minValue					:  this.ZoneList[this.ZoneList.length-1].min,
            maxValue					: this.ZoneList[0].max,
            
            minAngle					: -81,
            maxAngle					: 81,
            
            transitionMs				: 1550,
            
            majorTicks					: this.majorTicks,
           // labelFormat					: d3.format('d.caption'),
            labelInset					: 10,
            
            arcColorFn					:  this.determineArcColor
        };

        if (this.props.setRefValueMode || this.props.loadableRefValueMode) {
          this.clearReferenceValuesBar();
          this.gaugeCreated = null;
        }

        if (!this.gaugeCreated || this.props.setRefValueMode || this.props.loadableRefValueMode)
        {
          
            
        this.gaugeCreated = d3.select("#gauge-" + this.props.overridename+ "-ttfm-gauge-" + this.props.title + "-" + this.props.context + ' .ttfm-gauge-reference-values')
        .append('svg')
        .attr('class', 'gauge')
        .attr('height', heightToUse)
        .attr('width', widthToUse);
 
          d3.pie();
          this.configure(defaultGaugeConfig);
          this.renderGauge(this.props.value, defaultGaugeConfig, this.gaugeCreated );
      }else
      {
        this.update(this.props.value === undefined ? 0 : this.props.value, defaultGaugeConfig,this.gaugeCreated);
      }
      }

      determineArcColor = (t) =>
      {
        let zoneIn = Math.round(this.majorTicks * (1-t))-1;
        let ZoneFound = this.ZoneList[zoneIn];
        return ZoneFound.color;
      }

      editValueClicked = (e) =>
      {
       this.setState({
         isediting: true,
       // overridevalue: valueIn 
       });
       e.stopPropagation();
      }

      blurValue = () =>
      {
       this.setState({
         isediting: false
       })
      }
      
      toggleEditMode = (e) => {
        if (!this.props.allow) {
          return;
        }
        
        this.setState(prevState => ({
          isediting: !prevState.isediting,
          editableConfig: {
            goodRange: { ...this.props.goodRange },
            badRange: { ...this.props.badRange },
            worstRange: { ...this.props.worstRange },
            goodColor: this.props.goodColor,
            badColor: this.props.badColor,
            worstColor: this.props.worstColor,
            enableColouring: this.props.enableColouring
          },
          editValue: this.props.value
        }));
        
        if (e) {
          e.stopPropagation();
        }
      }



      handleToggleColorGrading = () => {
        this.setState(prevState => ({
          editableConfig: {
            ...prevState.editableConfig,
            enableColouring: !prevState.editableConfig.enableColouring
          }
        }));
      }
      

      handleValueChange = (e) => {
        const newValue = e.target.value;
        this.setState({ editValue: newValue });
        
        if (this.props.tileValueChanged) {
          this.props.tileValueChanged(this.props.title, newValue);
        }
      }



      render() {
        let rightHtml: React.ReactFragment;
        if (this.props.includeEdit) {
            rightHtml = (
              <div className="gauge-title-right">
                <i className="material-icons"
                  onClick={this.editValueClicked}>
                  edit
                </i>
              </div>
            );
          }
        
      
        if (this.props.includeSubValue) {
          rightHtml = <div className="gauge-subvalue BPM-value">{this.props.subValue}<br/><div className="gauge-title-right BPM">{this.props.subValueUom}</div></div>;
        }

        let valueFragment = null;
      
        if(!this.props.setRefValueMode)
          {
            valueFragment = <div className={"gauge-value "+(this.props.valueStale?"gauge-value-stale":"")}> 
            {this.props.value === undefined || this.props.value === "--"
              ? "--"
              :(this.props.value > this.props.maxValue ? this.props.maxValue: this.props.value).toFixed(1)}
            </div>;

            if (this.state.isediting) {
              valueFragment = <div className="gauge-value"> <input className="gauge-value-input" type="text" autoFocus={true} defaultValue={this.props.value} onBlur={this.blurValue} onChange={(e)=>{this.props.tileValueChanged(this.props.title, e.target.value);}} /></div>;
            }
            
          }
        

      
        let referenceValuesTop: React.ReactFragment;
        referenceValuesTop = <div className={"ttfm-gauge-reference-values ttfm-gauge-reference-values-expanded"}>
        </div>;
      
        // Base gauge display
        const gaugeDisplay = (
          <div id={"gauge-" + this.props.overridename+"-ttfm-gauge-" + this.props.title+ "-" + this.props.context} className={"ttfm-gauge-container"}>
            <div className={(this.props.wideTile ? " TTFM-gauge-wide" : " TTFM-gauge-basic")} onClick={(e) => { this.props.tileClicked(e);}}>
              <div className="gauge-title">
                <div className="gauge-title">{this.props.title}</div>
              </div>
              <div className="gauge-middle">
                {referenceValuesTop}
                {this.renderOverlayInputs()}
              </div>
              <div className="gauge-bottom">
                {valueFragment}
                {rightHtml}
                <div className="gauge-uom"> {this.props.uom}</div>
              </div>
            </div>
          </div>
        );
      
      
        return gaugeDisplay;
      }

}

export default GaugeTile;